export default {
  "select-a-language": "选择语言",
  select: "选择",
  language: "中文".toUpperCase(),
};
